import Seo from "@/components/Seo";
import ContactSection from "@/components/ContactSection";
import { PAGE_META } from "@/lib/seo-constants";
import { breadcrumbSchema } from "@/lib/jsonld";

export default function Contact() {
  const meta = PAGE_META.contact;

  return (
    <>
      <Seo
        title={meta.title}
        description={meta.description}
        path={meta.path}
        jsonLd={[
          breadcrumbSchema([
            { name: "Home", path: "/" },
            { name: "Contact", path: "/contact" },
          ]),
        ]}
      />

      <section className="bg-charcoal py-16 text-center">
        <div className="section-container">
          <p className="font-display text-sm uppercase tracking-[0.3em] text-brick-light">
            Contact
          </p>
          <h1 className="mt-3 font-display text-4xl font-semibold text-offwhite sm:text-5xl">
            Get In Touch
          </h1>
        </div>
      </section>

      <section className="py-20">
        <div className="section-container">
          <ContactSection />
        </div>
      </section>
    </>
  );
}
